export default {
  methods: {
    userIsGuest () {
      return this.$engine.user.activeAccount === '3'
    }
  }
}
